
import React from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Send, Loader2 } from "lucide-react";
import VoiceInput from "./VoiceInput";

interface ChatInputProps {
  inputValue: string;
  setInputValue: (val: string) => void;
  onSendMessage: () => void;
  isLoading: boolean;
  requestInProgress: boolean;
  inputRef: React.RefObject<HTMLTextAreaElement>;
  onKeyDown: (e: React.KeyboardEvent) => void;
}

const ChatInput: React.FC<ChatInputProps> = ({
  inputValue,
  setInputValue,
  onSendMessage,
  isLoading,
  requestInProgress,
  inputRef,
  onKeyDown,
}) => {
  const handleVoiceTranscription = (text: string) => {
    setInputValue(text);
    // Opcional: activar el foco en el textarea después de la transcripción
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <div className="p-3 border-t">
      <div className="flex gap-2">
        <Textarea
          ref={inputRef}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={onKeyDown}
          placeholder={requestInProgress ? "Enviando mensaje..." : "Escribe tu pregunta aquí..."}
          className="flex-grow resize-none min-h-[60px] max-h-[120px]"
          disabled={isLoading || requestInProgress}
        />
        <div className="flex flex-col gap-2 self-end">
          <VoiceInput 
            onTranscription={handleVoiceTranscription} 
            isDisabled={isLoading || requestInProgress}
          />
          <Button
            onClick={onSendMessage}
            disabled={!inputValue.trim() || isLoading || requestInProgress}
            className={`${requestInProgress ? "bg-gray-400" : "bg-vegana-primary hover:bg-vegana-primary/90"}`}
            aria-label="Enviar mensaje"
          >
            {isLoading || requestInProgress ? (
              <Loader2 className="h-5 w-5 animate-spin" />
            ) : (
              <Send className="h-5 w-5" />
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ChatInput;
